import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Dashboard.css';
import '../styles/main.css';
import { Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Changemasterheader = () => {
  const [formData, setFormData] = useState({
    headerText: '',
    image: null,
  });

  const [entries, setEntries] = useState([
    {
      id: 1,
      headerText: 'ePARINAM Ministry of Tourism',
      image: 'https://via.placeholder.com/150', // Example image URL
      isActive: true,
    },
  ]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setFormData((prev) => ({ ...prev, image: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newEntry = {
      id: entries.length + 1,
      headerText: formData.headerText,
      image: URL.createObjectURL(formData.image),
      isActive: true,
    };
    setEntries([...entries, newEntry]);
    setFormData({ headerText: '', image: null });
  };

  const handleClear = () => {
    setFormData({ headerText: '', image: null });
  };

  const columns = [
    {
      name: 'S. No.', selector: row => row.id, width: '180px',
      center: true,

      style: {
        borderRight: '1px solid #dee2e6',
      },
    },
    {
      name: 'Header Text', selector: row => row.headerText, width: '230px',
      center: true,
  width:'300px',
      style: {
        borderRight: '1px solid #dee2e6',
    
      },
    },
    {
      name: 'Header Banner',
      cell: row => <img src={row.image} alt="Header" width={100} height={60} />,

      center: true,
width:'250px',
      style: {
        borderRight: '1px solid #dee2e6',
      },
    },
    {
     name: 'IsActive',
  selector: row => row.isActive ? 'Active' : 'Inactive',
  cell: row => (
    <span style={{ color: row.isActive ? 'green' : 'red', }}>
      {row.isActive ? 'Active' : 'Inactive'}
    </span>
  ),
  center: true,
  width:'190px',
  style: {
    borderRight: '1px solid #dee2e6',
  },
    },
    {
      name: 'Action',
    width:'140px',
      center: true,
      cell: () => (
        <>
          <button className="btn btn-outline-warning custompadding btn-sm me-2"><i className='bi bi-pencil'></i></button>
          <button className="btn btn-outline-danger custompadding btn-sm me-2"><i className='bi bi-trash'></i></button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="container mt-4 mb-4">
        <div className="d-flex justify-content-center gap-3">
          <Link to="/dashboard/setting">
            <Button variant="light" className="btn-btn-sechover">Change Email and SMTP Port</Button>
          </Link>
          <Link to="/dashboard/Changemasterheader">
            <Button variant="primary" className=" btn-btn-primary">Change Master Header</Button>
          </Link>
        </div>
      </div>

      <div className="container mt-4">
        <div className='row custombox'>
          <div className='rounded p-4 mb-4'>
            <div className="text-center customheader">
              <h5 className="mb-0">Add Header</h5>
            </div>

            <form onSubmit={handleSubmit} className="row ">
              <div className="col-md-6">
                <label className='mb-3'>Header Text</label>
                <input type="text" name="headerText" className="form-control" placeholder="ePARINAM" value={formData.headerText} onChange={handleChange} required />
              </div>
              <div className="col-md-6  add-departmentbtn">
                <label className='mb-3'>Upload Header Image <span className='text-muted'>(1920x234px)</span></label>
                <input type="file" name="image" className="form-control" onChange={handleChange} accept="image/*" required />
              </div>
              <div className="text-center mt-4">
                <Button variant="primary" type="submit" className="px-4 me-3 btn-fontweight btn-btn-primary">Add</Button>
                <Button variant="secondary" type="button" className="px-4  btn-fontweight" onClick={handleClear}>Clear</Button>
              </div>
            </form>
          </div>
        </div>



        <div className="row mt-4">
          <div className="card shadow-sm rounded-4 py-4 px-2  border-0 bg-white mb-custom">
            <h2 className="text-xl font-bold mb-4 page-heading">Header List</h2>

            <DataTable
              columns={columns}
              data={entries.map((dept, idx) => ({
                ...dept,
                _rowIndex: idx,
              }))}
              pagination

              striped
              responsive
              className="p-datatable-striped customuser-data-table customuser-data-table2 customarchive-data-table   dashboard-table"

              customStyles={{
                table: {
                  style: {

                    fontWeight: '600',
                    fontSize: '14px',
                    backgroundColor: '#f8f9fa',
                    textAlign: 'center',
                  },
                },
                headRow: {
                  style: {
                    backgroundColor: "#04364A!important",
                    minHeight: "48px",
                  },
                },
                headCells: {
                  style: {
                    padding: "10px 14px",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: "white",
                    textTransform: "uppercase",

                  },
                },
                rows: {
                  style: {
                    borderBottom: "1px solid #fdfdfd",
                    "&:hover": {
                      backgroundColor: "#fdfdfd",
                    },
                  },
                },
                cells: {
                  style: {
                    padding: "10px 14px",
                    fontSize: "14px",
                    color: "#334155",
                  },
                },
              }}
              conditionalRowStyles={[
                {
                  when: (row) => row._rowIndex % 2 === 0,
                  style: { backgroundColor: '#f2f2f2' },
                },
                {
                  when: (row) => row._rowIndex % 2 !== 0,
                  style: { backgroundColor: '#ffffff' },
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Changemasterheader;
